import { makeRequest } from "./api";

// Fetch All Tickets
export const getAllTickets = async (params) => {
  return makeRequest("/api/ticket/admin/all", {
    method: "GET",
    params,
  });
};

// Update Ticket Status
export const updateTicketStatus = async (id, status) => {
  return makeRequest(`/api/ticket/admin/${id}/status`, {
    method: "PATCH",
    data: { status },
  });
};
